module.exports = __webpack_public_path__ + "img/-e- icon_search.0ec56b25.svg";